var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column"},[_c('header-bar',{ref:"header",attrs:{"subtitle-prop":_vm.subtitle,"switchlang":"switchlang"}}),_c('section',{staticClass:"MainSection"},[_c('router-view',{ref:"childrenView",staticClass:"view"})],1),_c('footer-bar',{ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }